var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"link",attrs:{"to":_vm.localePath(_vm.redirectLink),"exact":""}},[_c(_vm.currentIcon,{tag:"component",staticClass:"link__icon"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }